import RCTModal from 'Modal';
export { RCTModal };
